import { useState } from 'react';

import { Button, Field, Form, Notice } from '../components';
import { useAction } from '../hooks';
import { useSession } from '../auth/session';

/**
 * Sign in.
 *
 * Deliberately says nothing about *why* a sign-in failed. The server returns one message
 * for an unknown username and a wrong password alike, and this screen must not undo that
 * by guessing — SMA's login distinguished the two and handed anyone a way to discover
 * which accounts existed.
 */
export function SignIn(): JSX.Element {
  const { signIn } = useSession();
  const { run, error, busy } = useAction();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  return (
    <div className="signin">
      <div className="signin-card">
        <h1>Sign in</h1>
        <p>Use the credentials issued by your administrator.</p>

        {error !== null && <Notice kind="error">{error}</Notice>}

        <Form onSubmit={() => void run(() => signIn(username, password))}>
          <Field label="Username" value={username} onChange={setUsername} required />
          <Field
            label="Password"
            value={password}
            onChange={setPassword}
            type="password"
            required
          />
          <div className="form-actions">
            <Button type="submit" disabled={busy || username === '' || password === ''}>
              {busy ? 'Signing in…' : 'Sign in'}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}
